import { render, staticRenderFns } from "./ShareOptionsForm.vue?vue&type=template&id=104251ae&scoped=true"
import script from "./ShareOptionsForm.vue?vue&type=script&lang=js"
export * from "./ShareOptionsForm.vue?vue&type=script&lang=js"
import style0 from "./ShareOptionsForm.vue?vue&type=style&index=0&id=104251ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104251ae",
  null
  
)

export default component.exports